import React, {Component} from 'react'
import { Link } from 'react-router'
import {Container, Row, Col} from 'react-grid-system'

// STYLES
import styled from 'styled-components'

// IMAGES
import Image1 from '../../assets/images/ahresp.svg'
import Image2 from '../../assets/images/logo-turismo-portugal.svg'
import Image3 from '../../assets/images/logo_compete2020.svg'
import Image4 from '../../assets/images/logo_pt2020.svg'
import Image5 from '../../assets/images/logo_ue.svg'

import Facebook from '../../assets/images/ic-facebook.svg'
import Twitter from '../../assets/images/ic-twitter.svg'

import Scroll from 'react-scroll-to-element'

export default class Footer extends Component {
  render () {
    const {t} = this.props

    return (
      <FooterContent>
        <Container>
          <Row>
            <Col md={3} sm={6} xs={12}>
              <FooterTitle>
                                        AHRESP - Quality
              </FooterTitle>
              <MenuItem>
                <Scroll type='id' element='banner'>
                  {t('Programa Quality')}
                </Scroll>
              </MenuItem>
              <MenuItem>
                <Scroll type='id' element='recipients' offset={-60}>
                  {t('Destinatários')}
                </Scroll>
              </MenuItem>
              <MenuItem>
                <Scroll type='id' element='advantages' offset={-60}>
                  {t('Vantagens')}
                </Scroll>
              </MenuItem>
              <MenuItem>
                <Scroll type='id' element='qualification' offset={-60}>
                  {t('Eventos')}
                </Scroll>
              </MenuItem>
              <MenuItem>
                <Scroll type='id' element='studies' offset={-60}>
                  {t('Estudos')}
                </Scroll>
              </MenuItem>
              <MenuItem>
                <Scroll type='id' element='practices' offset={-60}>
                  {t('Boas Práticas')}
                </Scroll>
              </MenuItem>
              <MenuItem>
                <Scroll type='id' element='platform' offset={-60}>
                  {t('Promoção')}
                </Scroll>
              </MenuItem>
            </Col>
            <Col md={3} sm={6} xs={12}>
              <FooterTitle>
                {t('F_Contactos')}
              </FooterTitle>
              <FooterMenuF>
                <Link href='mailto:info@quality.ahresp.com' target='_top' >
                                    info@quality.ahresp.com
                </Link>
              </FooterMenuF>
              <FooterMenuF>
                                + 351 213 527 060
              </FooterMenuF>
            </Col>
            <Col md={6} sm={12} xs={12}>
              <Sponsers>
                <Col md={6} sm={6} xs={12}>
                  <FooterTitle>
                    {t('F_Promotor')}
                  </FooterTitle>
                  <SponsersImage1 src={Image1} />
                </Col>
                <Col md={6} sm={6} xs={12}>
                  <FooterTitle>
                    {t('F_Apoio')}
                  </FooterTitle>
                  <SponsersImage2 src={Image2} />
                </Col>
              </Sponsers>
              <Sponsers2>
                <Col md={12} sm={12} xs={12}>
                  <FooterTitle>
                    {t('F_Cofinanciado')}
                  </FooterTitle>
                  <SponsersImage3 src={Image3} />
                  <SponsersImage3 src={Image4} />
                  <SponsersImage4 src={Image5} />
                </Col>
              </Sponsers2>
            </Col>
          </Row>
        </Container>
        <Container>
          <FooterBottom>
            <ColLeft>
                            © AHRESP - 2018. {t('Todos os direitos reservados')}
            </ColLeft>
            <ColRight>
              <a href='https://www.facebook.com/programaquality/' target='_blank' rel='noopener noreferrer'><img src={Facebook} alt='' /></a>
              <a href='https://twitter.com/ProgramaQuality' target='_blank' rel='noopener noreferrer'><img src={Twitter} alt='' /></a>
            </ColRight>
          </FooterBottom>
        </Container>
      </FooterContent>
    )
  }
}

const FooterContent = styled.div`
    width: 100%;
    background-color: #2E84C6;
    padding-top: 40px;
    text-align: left;
    overflow: hidden;

    @media screen and (max-width: 575px) {
        text-align: center;
    }
`
const FooterTitle = styled.h5`
    color: #FFF;
    font-family: Dosis;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    margin-bottom: 20px;
    margin-top: 20px;

`
const MenuItem = styled.p`
    color: #FFF;
    font-family: "Source Sans Pro";
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;
    text-decoration: none;

    a{
        color: #FFF;
        font-family: "Source Sans Pro";
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
        text-decoration: none;
    }
`
const FooterMenuF = styled.p`
    color: #FFF;
    font-family: "Source Sans Pro";
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;
    text-decoration: none;

    a{
        color: #FFF;
        font-family: "Source Sans Pro";
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
        text-decoration: none;
    }
`
const Sponsers = styled.div`
    display: flex;

    @media screen and (min-width: 575px && max-width:767px) {
        float: left;
    }
`
const Sponsers2 = styled.div`
    display: flex;
    flex-direction: row;

    @media screen and (max-width: 575px) {
        display: flex;
        flex-direction: column;
        
    }

`
const SponsersImage1 = styled.img`
    width: calc(90% - 8px);
    height: auto;

    @media screen and (max-width: 767px) {
        width: 50%;
        margin-left: 0;
        margin-right: 0;
    }
`
const SponsersImage2 = styled.img`
    width: calc(90% - 8px);

    @media screen and (max-width: 767px) {
        width: 50%;
        margin-left: 0;
        margin-right: 0;
    }
`
const SponsersImage3 = styled.img`
      width: calc(27% - 8px);
      padding-top: 5px;
      padding-bottom: 5px;
      padding-left: 10px;
      padding-right: 10px;

      @media screen and (max-width: 575px) {
        width: 40%;
        padding-top: 10px;
        margin-left: 15px;
        margin-right: 15px;
}
`
const SponsersImage4 = styled.img`
      width: 35%;
      padding-top: 5px;
      padding-bottom: 5px;
      padding-left: 10px;
      padding-right: 10px;

      @media screen and (max-width: 575px) {
        width: 45%;
        padding-top: 10px;
        margin-left: 5px;
        margin-right: 5px;
}
`

const FooterBottom = styled.div`
    border-top: 1px solid #FFF;
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
`
const ColLeft = styled.div`
    color: #FFF;
    font-family: "Source Sans Pro";
    font-size: 12px;
    line-height: 15px;
`
const ColRight = styled.div`
    a{
        cursor: pointer;
    }

    a:nth-child(2){
        margin-right: 8px;
        margin-left: 8px;
    }
`



// WEBPACK FOOTER //
// ./src/sections/footer/footer.section.js